import WidgetCard from "@/components/cards/widget-card";
import MainTable from "@/components/table";
import { useTanStackTable } from "@/components/table/custom/use-TanStack-Table";
import { reportAnalyticsData } from "@/data/crm-dashboard-data";
import cn from "@/utils/class-names";
import { Link } from "react-router-dom";
import { Button } from "rizzui";
import { defaultColumns } from "./column";

export type ReportAnalyticsDataType = (typeof reportAnalyticsData)[0];

export default function ReportAnalytics({ className }: { className?: string }) {
    const { table } = useTanStackTable<ReportAnalyticsDataType>({
        tableData: reportAnalyticsData,
        columnConfig: defaultColumns,
        options: {
            initialState: {
                pagination: {
                    pageIndex: 0,
                    pageSize: 5,
                },
            },
            enableSorting: false,
            enableColumnResizing: false,
        },
    });

    return (
        <WidgetCard
            title="Report Analytics"
            headerClassName="items-center"
            className={cn("space-y-4", className)}
            action={
                <Link to={"#"}>
                    <Button as="span" variant="text" className="underline">
                        View All
                    </Button>
                </Link>
            }
        >
            <MainTable
                table={table}
                variant="minimal"
                classNames={{
                    container: "[&>table>thead>tr>th]:whitespace-nowrap",
                }}
            />
        </WidgetCard>
    );
}
